import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ClientsWall } from "./ClientsWall";
import { useLang } from "../i18n";

const ease = [0.22, 1, 0.36, 1];

export const ClientsSection = () => {
  const { lang, s } = useLang();
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  return (
    <section id="clients" data-testid="clients-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <p className="text-luxury-gold text-sm tracking-[0.35em] mb-6">{s.clients_eyebrow}</p>
          <h2 className="font-serif font-bold text-4xl sm:text-5xl text-luxury-bone leading-[1.25]">
            {s.clients_title_a} <span className="gold-gradient-text italic">{s.clients_title_b}</span>
          </h2>
        </motion.div>
        <ClientsWall compact />
        <div className="text-center mt-12">
          <Link
            to="/corporate"
            data-testid="clients-corporate-link"
            className="inline-flex items-center gap-2 border border-luxury-gold/60 text-luxury-gold px-8 py-3.5 rounded-full hover:bg-luxury-gold hover:text-luxury-black transition-colors duration-300 text-sm font-semibold"
          >
            {s.clients_cta}
            <Arrow className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </section>
  );
};
